import React from 'react'

const Image = ({ src, alt, h = 20, w = 20, style }) => {
  return (
    <img src={src} alt={alt} height={h} width={w} style={style} />
  )
}

export default Image